import Home from './pages/Home';
import Blocks from './pages/Blocks';
import License from './pages/License';
import FreeVsPro from './pages/FreeVsPro';

import {_getUrlParams} from '../functions';
 
const RootLayout = () => {

	let routePage = '';
	
	const params = _getUrlParams();

	if( params.page === 'riovizual' ){
		switch ( params.path ){
			case 'blocks':
				routePage = <Blocks/>;
				break;
			case 'freeVsPro':
				routePage = <FreeVsPro/>;
				break;
			case 'license':
				routePage = <License/>;
				break;
			default:
				routePage = <Home/>;
				break;
		}
	}

	return (
		<main className='rv_dash-container'>{ routePage }</main>
	)
}

export default RootLayout;
